<template>
    <div
      data-cy="list-item"
      :class="{
        'd-flex white': true,
        '': $breakpoints.smAndDown,
        'flex-column': $breakpoints.mdAndUp
      }"
      :style="[
        {
          padding: '10px 26px 14px 18px',
          boxShadow: `0 ${$getScaledCssValue('6px')} ${$getScaledCssValue(
            '20px'
          )} #AAAAAA65`,
          marginBottom: $getScaledCssValue('22px')
        },
        $breakpoints.mdAndUp && {
          padding: `${$getScaledCssValue('17px')} ${$getScaledCssValue(
            '33px'
          )} ${$getScaledCssValue('12px')} ${$getScaledCssValue('24px')}`
        }
      ]"
    >
      <div class="d-flex flex-column flex-grow-1" :style="{ minWidth: 0 }">
        <div class="d-flex justify-space-between align-center">
          <SkeletonLoader
            :showItem="item !== null"
            type="text"
            width="100"
            :style="{ width: '100%', minWidth: 0 }"
          >
            <template #item>
              <div
                data-cy="list-item-title"
                class="text-p6"
                :style="{
                  color: color,
                  whiteSpace: 'nowrap',
                  maxWidth: '500px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }"
              >
                 {{ item.title }}
              </div>
            </template>
          </SkeletonLoader>
          <SkeletonLoader
            v-if="!$breakpoints.smAndDown"
            :showItem="item !== null"
            type="text"
            width="100"
            :style="{
              marginLeft: '8px'
            }"
            ><template #item
              ><div class="text-p4" :style="{ color: color }">
                <!-- {{ item.date ? item.date : item.type ? item.type : '' }} -->
                  {{item.submission_type.name}}
              </div></template
            ></SkeletonLoader
          >
        </div>
  
        <div
          v-if="!$breakpoints.smAndDown"
          class="text-mark-thin-16"
          :style="{ marginBottom: $getScaledCssValue('10px') }"
        >
          <SkeletonLoader
            :showItem="item !== null"
            type="text"
            width="200"
            :style="{
              whiteSpace: 'nowrap',
              maxWidth: '600px',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }"
          >
            <template #item>
              {{ item.additionalInfo }}
            </template>
          </SkeletonLoader>
        </div>
  
        <SkeletonLoader :showItem="item !== null" type="paragraph">
          <template #item>
            <div
              ref="purpose"
              :class="{
                'd-flex': true,
                'text-mark-light-16': $breakpoints.smAndDown,
                'text-p4': $breakpoints.mdAndUp
              }"
              :style="{
                maxHeight: $getScaledCssValue('73px'),
                overflowY: 'hidden',
                position: 'relative'
              }"
            >
              {{ item.description }}
              <div class="purpose-overflow-blur"></div>
            </div>
          </template>
        </SkeletonLoader>
  
        <div
          v-if="!$breakpoints.smAndDown"
          class="
            d-flex
            list-row
            align-center
            justify-space-between
            flex-column flex-md-row
          "
          :style="{
            marginTop: $getScaledCssValue('11px')
          }"
        >
          <SkeletonLoader
            :showItem="item !== null"
            type="text"
            class="d-flex flex-wrap"
            width="100"
            :style="{
              marginTop: $getScaledCssValue('-12px')
            }"
          >
            <template #item>
              <div
                v-for="(tag, index) in JSON.parse(item.tags)"
                :key="index"
                class="text-mark-light-16"
                :style="{
                  border: '1px solid #DBDBDB',
                  borderRadius: $getScaledCssValue('7px'),
                  padding: `4px ${$getScaledCssValue('12px')}`,
                  marginRight: $getScaledCssValue('12px'),
                  marginTop: $getScaledCssValue('12px'),
                  color: color
                }"
              >
                {{ tag }}
              </div>
            </template>
          </SkeletonLoader>
  
          <SkeletonLoader :showItem="item !== null" type="text" width="100">
            <template #item>
              <v-hover #default="{ hover }">
                <div class="d-flex align-center">
                  <div
                    data-cy="view-list-item-details"
                    class="text-mark-book-18"
                    @click="navigateToViewMore(item.uuid, item.type)"
                    :style="{
                      cursor: 'pointer',
                      color: color
                    }"
                  >
                    {{ $t("viewMoreMessage") }}
                  </div>
                  <Arrow
                    class="right"
                    :style="{
                      color: color,
                      opacity: hover ? 1 : 0,
                      transition: 'opacity 300ms ease-out'
                    }"
                    borderWidth="1px"
                    width="2px"
                  />
                </div>
              </v-hover>
            </template>
          </SkeletonLoader>
        </div>
      </div>
  
      <div
        v-if="$breakpoints.smAndDown"
        class="align-self-center"
        :style="{ marginLeft: '8px', cursor: 'pointer' }"
        @click="$emit('viewItemClicked')"
      >
        <Arrow class="right secondary--text" borderWidth="1px" width="8px" />
      </div>
    </div>
  </template>
  
  <script>
  import SkeletonLoader from '../../Utils/SkeletonLoader.vue'
  import Arrow from '../../Utils/Arrow.vue'
  import { checkHeightOverflowed } from '../../Utils/functions';
  
  export default {
    components: {
      SkeletonLoader,
      Arrow,
    },
  
    props: {
      name: {
        type: String,
        default: null
      },
      additionalInfo: {
        type: String,
        default: null
      },
      date: {
        type: [String, Number],
        default: null
      },
      description: {
        type: String,
        default: null
      },
      tags: {
        type: Array,
        default: null
      },
      type: {
        type: String,
        default: null
      },
      color: {
        type: String,
        default: '#ac832d'
      },
      uuid:{
        type: String,
        default: null
      },
      item: {
        type: Object,
        default: null
      }
    },
    breakpoints(){
    },
  
    methods: {
      navigateToViewMore() {
        this.$router.push({
          name: 'viewMore',
          params: {
            item: this.item,
            uuid: this.item.bitstream_uuid,
            type: this.item.submission_type.name,
          }
        })
      },
      },
      }
  </script>
  
  <style scoped>
  .purpose-overflow-blur {
    position: absolute;
    bottom: 0;
    left: 0;
    /*background: radial-gradient(ellipse at top, transparent, white);*/
    background: linear-gradient(transparent 0%, white 100%);
    display: none;
    width: 100%;
    height: 20px;
  }
  </style>
  